const STORAGE_KEY = "adminUiSkin";
const SHADCN_SKIN = "shadcn";
const ENV_KEY = "REACT_APP_ADMIN_UI_SKIN";

function getConfiguredAdminUiSkin() {
  const runtimeConfig =
    typeof window !== "undefined" && window.config ? window.config[ENV_KEY] : undefined;

  return process.env[ENV_KEY] || runtimeConfig;
}

export function isAdminUiSkinEnabled() {
  const storedSkin =
    typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
  const configuredSkin = getConfiguredAdminUiSkin();

  return (storedSkin || configuredSkin) === SHADCN_SKIN;
}

export function applyAdminUiSkin() {
  const params = new URLSearchParams(window.location.search);
  const requestedSkin = params.get(STORAGE_KEY);

  if (requestedSkin === SHADCN_SKIN) {
    localStorage.setItem(STORAGE_KEY, SHADCN_SKIN);
  }

  if (requestedSkin === "default" || requestedSkin === "off") {
    localStorage.removeItem(STORAGE_KEY);
  }

  const enabled = isAdminUiSkinEnabled();
  const adminRoute =
    window.location.pathname.startsWith("/admin") ||
    window.location.pathname.startsWith("/auth") ||
    window.location.pathname === "/";

  if (enabled && adminRoute) {
    document.documentElement.setAttribute("data-admin-ui-skin", SHADCN_SKIN);
    return;
  }

  document.documentElement.removeAttribute("data-admin-ui-skin");
}

export { ENV_KEY, STORAGE_KEY, SHADCN_SKIN };
